import { Col, Row, Typography } from 'antd';

import { FormOutlined, CaretRightOutlined } from '@ant-design/icons';

import { FormButton, FormDeleteButton } from 'common/components';
import ModalConfirm from 'common/components/modal/ModalConfirm';

const { Text } = Typography;

const PendingFormModal = ({
  visible,
  onClose,
  onCancelForm,
  onContinue,
  onNewForm,
  isValidating = false,
  isCanceling = false,
}) => {
  return (
    <ModalConfirm
      visible={visible}
      onCancel={onClose}
      width={500}
      footer={
        <Row justify='space-between'>
          <Col>
            <FormDeleteButton
              danger
              onClick={onCancelForm}
              disabled={isCanceling}
              text='Delete'
            />
          </Col>
          <Col>
            <FormButton
              type='secondary'
              onClick={onNewForm}
              icon={<FormOutlined />}
              text='New Form'
            />
            <FormButton
              type='primary'
              onClick={onContinue}
              loading={isValidating}
              text='Continue'
              icon={<CaretRightOutlined />}
            />
          </Col>
        </Row>
      }
    >
      <div style={{ textAlign: 'center', marginTop: 16, marginBottom: 24 }}>
        <Text
          strong
          style={{ fontSize: 18, display: 'block', marginBottom: 8 }}
        >
          Continue Previous Submission?
        </Text>
        <Text style={{ fontSize: 14 }}>
          We've found a submission which has been started. Would you like to
          continue, or start a new submission?
        </Text>
      </div>
    </ModalConfirm>
  );
};

export default PendingFormModal;
